import { Provider } from 'jotai';

import { Suspense, useEffect } from 'react';
import { store } from './lib/store';
import { Loading } from './components/Loading';
import { Router } from './pages';
import { useValidateSessionMutation } from './lib/queries';
import { LanguageProvider } from './providers/LanguageProvider';

let didInit = false;

export function App() {
  const validateSession = useValidateSessionMutation();

  useEffect(() => {
    if (!didInit) {
      didInit = true;
      validateSession.mutate();
    }
  }, [validateSession]);

  return (
    <Provider store={store}>
      <LanguageProvider>
        <Suspense fallback={<Loading />}>
          <Router />
        </Suspense>
      </LanguageProvider>
    </Provider>
  );
}
